// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__IrIPm","modalfloat":"Modal_modalfloat__i69+U","modalheader":"Modal_modalheader__3jTrS","close":"Modal_close__LZhdF"};